import AssessmentsSerializer from './base';

export default class Batch extends AssessmentsSerializer {}
